export {NavigationBarContainer as NavigationBarHOC} from './NavigationBarContainer';
export {navigationBarLinkProps, NavigationBarView as NavigationBar} from './NavigationBarView';



// WEBPACK FOOTER //
// ./src/js/components/views/NavigationBar/index.js